<template>
  <main class="main-content mt-0">
    <div
      class="page-header min-vh-100"
      style="background-image: url('/img/bg/login-bg.webp')"
    >
      <span class="mask bg-gradient-warning opacity-2"></span>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6 col-md-7 mx-auto text-center">
            <h1
              class="display-1 text-bolder text-white fadeIn1 fadeInBottom mt-5"
            >
              Error 500
            </h1>
            <h2 class="fadeIn3 fadeInBottom mt-3 text-white">
              Something went wrong
            </h2>
            <router-link class="m-0 navbar-brand" to="/">
              <argon-button color="warning" class="mt-4 fadeIn2 fadeInBottom"
                >Go to Homepage</argon-button
              >
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </main>
  <app-footer />
</template>
<script>
import AppFooter from "@/shared/PageLayout/Footer.vue";
import ArgonButton from "@/shared/Controls/ArgonButton.vue";
import { mapMutations } from "vuex";
export default {
  name: "SignupBasic",
  components: {
    AppFooter,
    ArgonButton,
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.toggleDefaultLayout();
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.toggleDefaultLayout();
  },
  methods: {
    ...mapMutations(["toggleDefaultLayout"]),
  },
};
</script>
